import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import { ProgramFilter, IntakeTermFilter, CampusesFilter, ApplicationStats } from '../components';

export function DesktopLayout() {
  return (
    <Flex p={10} gap={8} direction="column">
      <PageHeader title="Reports" />
      <Flex gap={2}>
        <Filter as={<ProgramFilter />} width="310px" />
        <Filter as={<CampusesFilter />} width="310px" />
        <Filter as={<IntakeTermFilter />} width="310px" />
      </Flex>
      <ApplicationStats />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
